// src/pages/Moderation/UsersViolationsPage/model/utils.ts
import { ModerationUser, RestrictionAgg } from './types';

export function buildRestrictionAgg(users: ModerationUser[]): RestrictionAgg[] {
  const map = new Map<number, number>();

  for (const u of users) {
    for (const r of u.restrictions ?? []) {
      map.set(r.restriction, (map.get(r.restriction) ?? 0) + (r.cnt ?? 0));
    }
  }

  return Array.from(map.entries())
    .map(([restriction, cnt]) => ({ restriction, cnt }))
    .sort((a, b) => b.cnt - a.cnt);
}

export function formatUsername(u: ModerationUser) {
  return u.username ? `@${u.username}` : '—';
}

export function restrictionsCount(u: ModerationUser) {
  return (u.restrictions ?? []).reduce((acc, r) => acc + (r.cnt ?? 0), 0);
}
